<template>
  <app-page-container :showNav="true">
    <div class="welcome">Well that led us to a 404 oopsie. 🦄</div>
  </app-page-container>
</template>

<script>
import AppPageContainer from "@/components/AppPageContainer";
import { mapState } from "vuex";

export default {
  name: "Error404Page",
  components: {
    AppPageContainer,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      isVerified: (state) => state.auth.verificationStatus,
    }),
  },
};
</script>

<style scoped>
.welcome {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 40px;
  font-weight: 600;
}
</style>